import { c as _c } from "react/compiler-runtime";
import { Hotel } from "@website/icons/components/hotel";
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { Loading } from "@website/ui/loading";
import { TextField } from "@website/ui/text-field";
import { replaceSnappTripBasedOnChannel } from "@website/utils/title-replace";
import { FC } from "react";
import styles from "@website/widget/login/components/b2b-inquiry/b2b-inquiry.module.scss";
import { B2BInquiryPropertiesTypes } from "@website/widget/login/components/b2b-inquiry/types";
import { useB2BInquiry } from "@website/widget/login/components/b2b-inquiry/use-b2b-inquiry";
export const B2BInquiry: FC<B2BInquiryPropertiesTypes> = properties => {
  const $ = _c(25);
  const {
    phoneNumber,
    contractId,
    onChangePhoneNumber,
    onChangeContractId,
    onSubmitPhoneNumber,
    isLoading,
    error
  } = useB2BInquiry(properties);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className={styles.title}>لطفا برای ورود اطلاعات زیر را وارد کنید.</div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = isLoading ? undefined : onSubmitPhoneNumber;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Hotel width={18} />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = Boolean(error);
  let t4;
  if ($[2] !== contractId || $[3] !== onChangeContractId || $[4] !== t3) {
    t4 = <TextField StartIcon={t2} error={t3} fullWidth={true} onChange={onChangeContractId} placeholder={"\u06A9\u062F \u0634\u0631\u06A9\u062A"} value={contractId} />;
    $[2] = contractId;
    $[3] = onChangeContractId;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <MaterialIcon name="phone_iphone" />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = Boolean(error);
  let t7;
  if ($[7] !== onChangePhoneNumber || $[8] !== phoneNumber || $[9] !== t6) {
    t7 = <TextField StartIcon={t5} error={t6} fullWidth={true} onChange={onChangePhoneNumber} placeholder={"\u0634\u0645\u0627\u0631\u0647 \u0645\u0648\u0628\u0627\u06CC\u0644"} value={phoneNumber} />;
    $[7] = onChangePhoneNumber;
    $[8] = phoneNumber;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t4 || $[12] !== t7) {
    t8 = <div className={styles.input}>{t4}{t7}</div>;
    $[11] = t4;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== error) {
    t9 = error && <div className={styles.info}><span className={styles["info-icon"]}><MaterialIcon name="info" variant="outlined" /></span>{error}</div>;
    $[14] = error;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== isLoading) {
    t10 = isLoading ? <Loading color="white" size="lg" /> : replaceSnappTripBasedOnChannel("\u062A\u0627\u06CC\u06CC\u062F \u0648 \u0648\u0631\u0648\u062F \u0628\u0647 \u0627\u0633\u0646\u067E\u200C\u062A\u0631\u06CC\u067E!");
    $[16] = isLoading;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10) {
    t11 = <div className={styles.footer}><Button color="secondary" fullWidth={true} size="large" type="submit" variant="contained">{t10}</Button></div>;
    $[18] = t10;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t1 || $[21] !== t11 || $[22] !== t8 || $[23] !== t9) {
    t12 = <div className={styles.container}>{t0}<form onSubmit={t1}>{t8}{t9}{t11}</form></div>;
    $[20] = t1;
    $[21] = t11;
    $[22] = t8;
    $[23] = t9;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  return t12;
};